import {Component} from '@angular/core';

@Component({
  selector: 'mz-dropdown-divider',
  templateUrl: './dropdown-divider.component.html',
  styleUrls: ['./dropdown-divider.component.scss'],
})
export class MzDropdownDividerComponent {
}
